import { Map, List, fromJS } from 'immutable'
import {
  SET_PM_SECTION,
  SET_PM_SECTION_ERROR,
  SET_PM_SECTION_DONE,
  SET_PM_SECTION_PROCESSING,
  DELETE_PM_SECTION,
  DELETE_MULTIPLE_PM_SECTIONS,
} from './actions'

export const initialState = Map()

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_PM_SECTION: {
      const { sectionId, data, done = false, processing = false } = action.payload
      return state.withMutations((mutableState) => {
        mutableState
          .setIn([sectionId, 'processing'], processing)
          .setIn([sectionId, 'done'], done)
          .setIn([sectionId, 'data'], fromJS(data))
          .deleteIn([sectionId, 'error'])
      })
    }
    case SET_PM_SECTION_DONE: {
      const { sectionId, done } = action.payload
      return state.setIn([sectionId, 'done'], done)
    }
    case SET_PM_SECTION_PROCESSING: {
      const { sectionId, processing = true } = action.payload
      return state.setIn([sectionId, 'processing'], processing)
    }
    case SET_PM_SECTION_ERROR: {
      const { sectionId, error, processing = false, done = true } = action.payload
      return state.withMutations((mutableState) => {
        mutableState
          .setIn([sectionId, 'processing'], processing)
          .setIn([sectionId, 'done'], done)
          .deleteIn([sectionId, 'data'])
          .setIn([sectionId, 'error'], error)
      })
    }
    case DELETE_PM_SECTION: {
      const { sectionId } = action.payload
      return state.delete(sectionId)
    }
    case DELETE_MULTIPLE_PM_SECTIONS: {
      const { sectionIds = List() } = action.payload
      return state.withMutations((mutableState) => {
        sectionIds.forEach(sectionId => mutableState.delete(sectionId))
      })
    }
    default:
      return state
  }
}

/*
Store
pmSection: Map(
  f52dfbd7-930e-4316-9516-00eaee4d6d2c: {
    processing: boolean,
    data: Map(),
    error: Map(),
  },
)
*/
